import { apiBeAuth } from "@/entities/auth";

export const PostFavoriteList = async () => {
  const responseBody = await apiBeAuth<PostFavoriteListRes>("/user/watchlist/list", {
    method: "POST",
  });

  return responseBody;
};
